module.exports = __webpack_public_path__ + "ccc0173492aa7e45bb8003397e9e8907.png";